import { Button } from 'antd';
import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import warning from '../../assets/images/warning.svg';

function ModalNotifyOffline({
    setShow,
    show,
    notify
}) {
    const { t } = useTranslation();

    const handleClose = () => setShow(false);

    return (
        <Modal onHide={handleClose} show={show} scrollable>
            <Modal.Header closeButton>
                <Modal.Title>{t('alert')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div>
                    <img src={warning} alt="warning" style={{ marginRight: '20px' }} />
                    {notify !== 0 ? t('notify-alert') : t('system-offline')}
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    {t('close')}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default ModalNotifyOffline;